(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lead-capture-form"] && !Shopify.designMode) return;
  try {
    const honeypotForm = document.getElementById('ContactForm');
    const honeypot = honeypotForm.querySelector('[data-contact-honeypot]');

    if (honeypotForm) {
        honeypotForm.addEventListener('submit', (event) => {
            if (!honeypot) return;

            if (honeypot.value.trim() !== '') {
                event.preventDefault();
                // show an error message once
            }
        });
    }
  } catch(e) { console.error(e); }
})();

})();
